<template>
  <div class="login-box">
    <div class="header-logo">
      <img src="../../assets/imgs/image.png" />
    </div>
    <div class="frm-box">
      <div class="title">{{ $t("login.login") }}</div>
      <div>
        <van-form @submit="onSubmit">
          <van-field
            v-model="username"
            :placeholder="$t('login.teldesc')"
            class="frm-item"
            :rules="[{ required: true }]"
          />
          <van-field
            v-model="password"
            type="password"
            :placeholder="$t('login.pwddesc')"
            class="frm-item"
            :rules="[{ required: true }]"
          />
          <div style="margin: 16px">
            <van-button native-type="submit" class="frm-btn">{{
              $t("login.login")
            }}</van-button>
          </div>
        </van-form>
        <p>{{ $t("login.forget") }}</p>
        <p>{{ $t("login.noaccount") }}</p>
        <div style="margin: 16px">
          <van-button class="frm-btn" @click="toReg">{{ $t("login.toregister") }}</van-button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer/index.vue";
import { Toast } from 'vant';
export default {
  name: "LoginView",
  components: { Footer },
  data() {
    return {
      username: null,
      lang: 'yn_yu',
      password: null,
    };
  },
  methods: {
    onSubmit() {
      this.$http({
        url: "member_login",
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          lang: this.lang,
        },
      }).then((res) => {
        if (res.code == 200) {
          Toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("/");
        } else {
          Toast(res.msg);
        }
      });
    },
    toReg() {
        this.$router.push({ name: "register" });
    }
  }
};
</script>
<style scoped>
</style>
